import { Component, OnInit } from '@angular/core';
import { AppRoutes } from '@app-routes';
import { LocalStorageService } from 'ngx-webstorage';
import Rxmq, { Channel } from 'rxmq';
import { AnalyticEvent } from '../../../shared/interfaces/analytic-event';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../services/spinner.service';
import { OAuth2Service } from '../../../services/auth/oAuth2.service';
import { AuthService } from '@services';

@Component({
  selector: 'app-auth-processing',
  templateUrl: './auth-processing.component.html',
  styleUrls: ['./auth-processing.component.scss'],
})
export class AuthProcessingComponent implements OnInit {
  code: string;

  dialogRef;

  constructor(
    private spinnerService: SpinnerService,
    private oAuth2Service: OAuth2Service,
    private authService: AuthService,
    protected storage: LocalStorageService,
    public route: ActivatedRoute,
    public router: Router,
  ) {}

  ngOnInit() {
    this.checkAuth();
  }

  checkAuth() {
    if (this.route.snapshot.queryParams.code) {
      this.code = this.route.snapshot.queryParams.code;
      this.oAuth2Service.tryLogin().then((data) => {
        this.loginOAuth2();
      });
    } else if (this.oAuth2Service.getToken()) {
      this.loginOAuth2();
      this.spinnerService.stop();
    } else {
      this.spinnerService.stop();
      this.router.navigate([AppRoutes.home]);
    }
  }

  loginOAuth2() {
    this.authService.loginOAuth().subscribe((data) => {
      const user = data;
      (this.authService.user as any).loginEmail = user.loginEmail;
      this.router.navigate([AppRoutes.dashboard, AppRoutes.invoices_my]);
      this.spinnerService.stop();
      this.storeLoggedIn();

      Rxmq.channel<Channel<AnalyticEvent>, AnalyticEvent, AnalyticEvent>(
        'analitics',
      )
        .subject(`app-auth-processing.login.success`)
        .next({
          eventLabel: `Увійти, успіх`,
          eventCategory: 'app-auth-processing',
          eventAction: 'submit.success',
        });
    });
  }

  storeLoggedIn(): void {
    this.storage.store(`loggedIn${this.authService.user.loginEmail}`, true);
  }
}
